import { logger } from 'client/utils/logger/logger';

export function handleReject(e) {
  logger.error(e);
  return Promise.reject(e);
}
